// extracted by mini-css-extract-plugin
export default {"section":"feed_section__VkAnh","title":"feed_title__Rzkfe","container":"feed_container__2U7wP"};